export default __webpack_public_path__ + "static/media/fsplus-space-planning.7f202d35.png";